import NavBar from '../components/Visual/Navbar'

export default function Invoices() {
    return (
     <div>
         <NavBar/>
         <h1>Home</h1>
     </div>
    );
  }